var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    stroke: "#000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.138 14.54l-4.989 5.85c-.19.225-.522.36-.855.36-.712 0-1.235-.63-1.045-1.26l2.043-5.94H5.541c-1.188 0-2.09-.99-1.853-2.115l1.14-6.3c.143-.855.95-1.485 1.853-1.485h9.312v8.64c0 .81-.285 1.62-.855 2.25zM17.9 12.65H16v-9h1.9c1.045 0 1.9.81 1.9 1.8v5.4c0 .99-.855 1.8-1.9 1.8z",
    strokeWidth: 1.4249999999999998
  }))));
}
export default SvgThumbDown;